import styled from 'styled-components'

export const AdminTableHeaderSection = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	min-height: 40px;
	background: #f9f9f9;
	padding: 10px;
`
